export default "__VITE_ASSET__3f394b2d__"